import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../../app/api";

export const fetchProductDetail = createAsyncThunk(
  "productDetail/fetchProductDetail",
  async ({ slug, sku }, { rejectWithValue }) => {
    try {
      if (!slug || !sku) {
        throw new Error("Both slug and sku are required");
      }

      // SINGLE API FORMAT ONLY
      const response = await API.get(`/product-details/${slug}/${sku}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const productsQuickViewSlice = createSlice({
  name: "quickView",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearProductDetail: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchProductDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearProductDetail } = productsQuickViewSlice.actions;
export default productsQuickViewSlice.reducer;